import React, { useState } from 'react';
import "./ReviewsModal.css";
import greyStar from "../../../assets/icons/grey_star.png";
import goldStar from "../../../assets/icons/gold_star.png";
import axios from 'axios';
import { toast } from 'react-toastify';
import { baseUrl } from '../../../common/baseUrl';
import axiosInstance from '../../../axiosInstance/axiosInstance';

export default function ReviewsModal(props) {
    const [rating, setRating] = useState(props?.requestData?.rating || 0); // store rating
    const [description, setDescription] = useState(props?.requestData?.ratingRemarks || ""); // store review description

    const userId = localStorage.getItem("user_id");
    const [errors,setErrors] = useState({});

    const ratingMessages = {
        1: "Really sorry. Please share your experience.",
        2: "Not great. Tell us what happened.",
        3: "Thanks. How can we improve this?",
        4: "Great job! Tell us what worked.",
        5: "Awesome! Tell us what you loved.",
    };

    // console.log("Props : ",props)


    
    // Validations
    const validateForm = ()=>{
        try{
            let newErrors = {};
            if(rating===0){
                newErrors.rating = "Please provide a rating";
            }
            setErrors(newErrors);
            return Object.keys(newErrors).length === 0;

        }catch(error){
            console.log(error);
        }
    }

    const changeRating=(star)=>{
        try{
            setRating(star)
            setErrors({});
        }catch(error){
            console.log(error);
        }
    }

    const handleChange = (e)=>{
        try{
            setDescription(e.target.value);
        }catch(error){
            console.log(error);
        }
    }


    const closeModal = ()=>{
        try{
          
            props.setIsReviewModal(false)
            props.setRequestData({})
            setErrors({});

            props.onClose?.();
        }catch(error){
            console.log(error)
        }

    }

    const handleSubmit = async()=>{
        try{
            if(!validateForm()){
                return;
            }
            // console.log("Request Data : ",props.requestData);
            // console.log("Desc : ",description);
            const userId = localStorage.getItem("user_id");
            const bookingId = props.requestData.bookingId;
            const bookedRoomId = props.requestData.bookedRoomId;
            const guestRequestId = props.requestData.guestRequestId;

            const passData = {
                rating : rating,
                description : description
            }

            const response = await axiosInstance.put(`/api/v1/users/${userId}/guest-requests/${guestRequestId}/rating`,passData); 
            if(props?.requestData?.requestType==="Dining"){
                const response1 = await axiosInstance.post(`/api/v1/users/${userId}/bookings/${bookingId}/booked-rooms/${bookedRoomId}/guest-requests/post-checkin/food-request/food-menu-rating?guest_request_id=${guestRequestId}`,passData)
            }
            if(props?.requestData?.requestType==="RestaurantDining"){
                const response1 = await axiosInstance.post(`/api/v1/users/${userId}/hotels/${props?.requestData?.hotelId}/restaurant-food-request/food-menu-rating?guest_request_id=${guestRequestId}`,passData)            
            }
            

            props.setIsReviewModal(false)
            props.setRequestData({})
            setErrors({});

            props.onSubmitted?.();


        }catch(error){
            console.log(error);
            // Keep the sheet open, otherwise a failed rating looks exactly like
            // a saved one
            toast.error(error?.response?.data?.message || "We couldn't save your rating. Please try again.");
        }
    }

    return (
        <>
            <span className='close-review-bar' onClick={()=>{closeModal()}}>x</span>
            <div className={`review-bar`}>

                {/* Stars Bar */}
                <div className='review-bar-stars'>
                    <div className='review-stars'>
                        {[1, 2, 3, 4, 5].map((star) => (
                            <span
                                key={star}
                                className="review-star"
                                onClick={() => changeRating(star)}
                                style={{ cursor: "pointer" }}
                            >
                                <img
                                    src={star <= rating ? goldStar : greyStar}
                                    alt="star"
                                />
                            </span>
                        ))}
                    </div>
                    {/* Rating Message */}
                    {rating > 0 && (
                        <div className="rating-message">
                            <p>{ratingMessages[rating]}</p>
                        </div>
                    )}
                    {errors.rating && <span className='error-message'>{errors.rating}</span>}
                </div>

                {/* Review Description */}
                <div className='review-description'>
                    <h4>
                        Share more about your experience
                    </h4>

                    <textarea name="description" value={description} onChange={(e)=>{handleChange(e)}} ></textarea>
                </div>

                {/* Button */}
                {
                    props.requestData.view==="view" ? <p></p> :  <div className='review-button'>
                    <button onClick={()=>handleSubmit()} >Submit</button>
                </div>
                }
               

            </div>
        </>
    );
}
